<h3>Choose a variable and adjust your plan</h3>

<div class="plan-slider-var-container" style="margin-bottom: 20px;">
  <div class="plan-slider-var-row">
    <div (click)="adjustableVariable=option.type"
         *ngFor="let option of options"
         [class.plan-slider-var-selected]="adjustableVariable === option.type">
      <button
        (click)="adjustableVariable=option.type"
        [attr.data-testing]="'pyl-preview-adjust-'+option.type+'-btn'" class="plan-slider-var-btn">
        {{option.label}}
      </button>
    </div>
  </div>
</div>

<div *ngIf="adjustableVariable === options[0].type"
     class="pyl-preview-adjust-expenses-slider"
     aria-live="assertive">

  <popover-help [useAsTemplate]="true">
    <div [innerHTML]="options[0].popover"></div>
  </popover-help>

  <h3>{{options[0].header}}</h3>

  <eync-last-month-household-expenses-totalled [expenses]="form.get('ongoingExpenses').get('lastMonthsHouseHoldLivingExpenses').value">
  </eync-last-month-household-expenses-totalled>

  <ey-slider
    (reset)="restoreExpensesValue()"
    (valueChange)="updateExpensesValue($event)"
    [max]="20000"
    [min]="0"
    [showReset]="true"
    [step]="100"
    [type]="EySliderTypeEnum.currency"
    [value]="form.get('ongoingExpenses').get('monthlyExpensesToCover').value"
    ariaLabelledBy="slider-variable-label">
  </ey-slider>

</div>

<div
  *ngIf="adjustableVariable === options[1].type"
  class="pyl-preview-adjust-time-slider"
  aria-live="assertive">

  <popover-help [useAsTemplate]="true">
    <div [innerHTML]="options[1].popover"></div>
  </popover-help>

  <h3>{{options[1].header}}</h3>

  <ey-slider
    (reset)="restoreTimeValue()"
    (valueChange)="updateTimeValue($event)"
    [max]="timeSliderMaxValue"
    [min]="0"
    [showReset]="true"
    [step]="1"
    [type]="EySliderTypeEnum.normal"
    [value]="form.get('ongoingExpenses').get('yearsToCover').value"
    ariaLabelledBy="slider-variable-label">
  </ey-slider>

</div>
